import React from 'react';
import { motion } from 'framer-motion';

interface HamburgerIconProps {
  isOpen: boolean;
  isWhite?: boolean;
  className?: string;
}

const HamburgerIcon: React.FC<HamburgerIconProps> = ({
  className = '',
  isOpen,
  isWhite = false,
}) => {
  const strokeColor = isWhite ? 'white' : 'black';
  const strokeWidth = isWhite ? 3 : 2;
  const width = 30;
  const height = 30;

  return (
    <motion.svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      animate={{ rotate: isOpen ? 0 : 0 }}
      transition={{ duration: 0.3, ease: 'easeInOut' }}
    >
      {/* Top line - transforms to top part of X */}
      <motion.path
        d="M4 8L26 8"
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        animate={{
          d: isOpen ? 'M6 6L24 24' : 'M4 8L26 8',
        }}
        transition={{ duration: 0.3, ease: 'easeInOut' }}
      />

      {/* Middle line - fades out when open */}
      <motion.path
        d="M4 15L26 15"
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        initial={{
          opacity: 1,
          x: 0,
        }}
        animate={{
          opacity: isOpen ? 0 : 1,
          x: isOpen ? 10 : 0,
        }}
        transition={{ duration: 0.2, ease: 'easeInOut' }}
      />

      {/* Bottom line - transforms to bottom part of X */}
      <motion.path
        d="M4 22L26 22"
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        animate={{
          d: isOpen ? 'M6 24L24 6' : 'M4 22L26 22',
        }}
        transition={{ duration: 0.3, ease: 'easeInOut' }}
      />
    </motion.svg>
  );
};

export default HamburgerIcon;
